<template>
    <v-card outlined elevation="1" class="summary-card">
        <v-card-text class="text-center" py-6>
            <h5 class="text-h5 mb-3">{{ title }}</h5>
            <h6 class="text-h6 primary--text">{{ amount }}</h6>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'cash-summary-card',
  props: {
    title: { type: String, required: true },
    amount: { type: String, required: true },
  },
};
</script>

<style scoped>
.summary-card {
    border-radius: 10px;
}
</style>
